import { render, staticRenderFns } from "./MtStock.vue?vue&type=template&id=2071dabe&"
import script from "./MtStock.vue?vue&type=script&lang=js&"
export * from "./MtStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports